module.exports = __webpack_public_path__ + "img/no-internet.27c3f9fa.gif";